import React, { useState } from 'react';
// import { Query } from 'react-apollo';
import styled from 'styled-components';
// import { withProp } from 'styled-tools';
import { useQuery } from '@apollo/client';
// import DatePicker from "react-datepicker";
import Intl from '../../components/common/Intl';
import { theme } from 'styled-tools';

// Styled Components
import { Amount, Income } from '../../components/common/NumberDisplay';
import Openable from '../../components/common/Openable';
import Spinner from '../../components/common/Spinner';
import { Col,TableBodyWrapper, TableWrapper } from '../../components/common/table/baseTableStyles';
import EmptyRow from '../../components/common/table/feature/EmptyRow';
import { EOddsType } from '../../components/eu-content/NumberInput';
import DatePickerIcon from 'src/images/calendar.png';

import {
    DateText,
    DetailWrapper,
    EventNameWithChevron,
    MemberTableBodyRow,
    MobileHead,
    RemarkItemTime,
    RemarkItemWrapper,
    RemarkSectionTitle,
    RemarkSectionWrapper,
    SelectionInfoWrapper,
    StatusText,
    TimeText,
    TypeLabel,
} from '../../components/member/membertablestyles';
import { TimeZone } from '../../store/TimeZoneContext';

// Utils
// import { diffColor } from '../../util/colorUtil';
// import media from '../../util/mediaUtil';
import oddsUtil from '../../util/oddsUtil';
import util from '../../util/util';

// graph
import { GET_MY_ORDERS } from '../../graphql/member';
import { IOrder, IOrderGroup } from '../../graphql/schema';
import { EMarketType } from '../../util/utilModel';

export enum EHistoryTableType {
    current = 'CURRENT',
    past = 'PAST',
}

export enum EHistoryFilterType {
    matched = 'MATCHED',
    unmatched = 'UNMATCHED',
    both = 'BOTH',
}

const Description: React.SFC<{
    eventName: string;
    marketName: string;
    selectionName: string;
    orderNumber: string;
    marketType: number;
    matchedTime: string | number | Date;
    isSettled: boolean;
    remark: string;
    type: string;
    mode: string;
}> = props => {
    const {
        eventName,
        marketName,
        selectionName,
        matchedTime,
        orderNumber,
        isSettled,
        remark,
        marketType = EMarketType.MAIN,
        type,
        mode,
    } = props;
    return (
        <Openable>
            {({ isOpened, toggleOpen }) => {
                const hasRemark = !!remark;
                const remarks = (hasRemark && remark.split('||')) || [];
                return (
                    <>
                        <EventNameWithChevron
                            onClick={toggleOpen}
                            isOpened={isOpened}
                            withRemark={hasRemark}
                            historyFilterType={type}
                            historyTableType={mode}
                        >
                            {eventName}
                        </EventNameWithChevron>
                        {isOpened && (
                            <>
                                <SelectionInfoWrapper>
                                    {marketType === EMarketType.MAIN || EMarketType.Multi_Selection_Fancy ? (
                                        <>
                                            <span>{marketName}</span>
                                            <span>{selectionName}</span>
                                        </>
                                    ) : (
                                        <span>
                                            {selectionName} - runs ({marketName})
                                        </span>
                                    )}
                                </SelectionInfoWrapper>
                                <DetailWrapper>
                                    <span>
                                        BET NUMBER
                                    </span>
                                    <span> {orderNumber}</span>
                                </DetailWrapper>
                                <DetailWrapper>
                                    <span>
                                        {isSettled ? <span>PLACED</span> : <span>MATCHED</span>}
                                    </span>
                                    <span>
                                        <TimeZone format="dd/MM/yyyy HH:mm:ss">{matchedTime}</TimeZone>
                                    </span>
                                </DetailWrapper>
                                {Array.isArray(remarks) &&
                                    remarks.map((r, i) => {
                                        const remarkInfo = (r && r.split('|')) || [];

                                        if (remarkInfo.length <= 0) {
                                            return <span />;
                                        }
                                        const date = remarkInfo[0] || new Date().toISOString();
                                        return (
                                            <RemarkSectionWrapper>
                                                <RemarkSectionTitle>Remarks</RemarkSectionTitle>
                                                <div>
                                                    <RemarkItemWrapper>
                                                        {(remarkInfo[1] && remarkInfo[1].split(':')[1]) || ''}
                                                        <RemarkItemTime>
                                                            <TimeZone format="dd/MM/yyyy">{date}</TimeZone>
                                                            {/* {` ${remarkInfo[1]}`} */}
                                                        </RemarkItemTime>
                                                    </RemarkItemWrapper>
                                                </div>
                                            </RemarkSectionWrapper>
                                        );
                                    })}
                            </>
                        )}
                    </>
                );
            }}
        </Openable>
    );
};

interface IHistoryTableProps {
    mode: EHistoryTableType.current | EHistoryTableType.past | 'empty';
    query: {
        from: Date;
        to: Date;
        type: string;
    };
}

function showStatus(status: string) {
    switch (status) {
        case 'SETTLED':
            return 'SETTLING';

        default:
            return status;
    }
}

 export default function HistoryTable(props: IHistoryTableProps) {
    // const [startAt, setStartAt] = useState(new Date());
    // const [endAt, setEndAt] = useState(new Date());
    // const types = [EHistoryFilterType.matched, EHistoryFilterType.unmatched, EHistoryFilterType.both];
    // const [from, setFrom] = useState(new Date(new Date().setHours(0,0,0)));
    // const [to, setTo] = useState(new Date(new Date().setHours(23, 59, 59)));
    // const [type, setType] = useState(JSON.stringify(EHistoryFilterType.unmatched))
    // const { mode } = props
    const {
        mode,
        query: {type, from, to },
    } = props;

    let timeColLangKey: any;
    switch (mode) {
        case EHistoryTableType.current:
				timeColLangKey = <Intl langKey= 'HISTORY_TABLE@PLACED' />;
				break;
			case EHistoryTableType.past:
				timeColLangKey = <Intl langKey= 'HISTORY_TABLE@SETTLED' />;
				break;
			default:
				console.warn('[HistoryTable]: mode prop is invalid!');
				timeColLangKey = 'TIME';
    }
    const isSettled = mode === EHistoryTableType.past;


    const { data, loading, error } = useQuery(GET_MY_ORDERS, {
        variables: {
            input: { isSettled, period: { start: from.valueOf(), end: to.valueOf() } },
        }
    });


    const orderGroup: IOrderGroup = util.getValue(data, ['exchange', 'myOrders'], {
        matched: [],
        unmatched: [],
    });
     let orders = isSettled
         ? orderGroup.matched
         : type === EHistoryFilterType.both
             ? [...orderGroup.matched, ...orderGroup.unmatched].sort((a, b) => b.createdAt - a.createdAt)
             : type === EHistoryFilterType.matched
                 ? orderGroup.matched
                 : orderGroup.unmatched;
     orders = orders.slice().sort((a, b) => b.settledAt - a.settledAt)            
    //  orders = orders.sort((a, b) => b.settledAt - a.settledAt);
    //  if (orders.length === 0) {
    //      return <EmptyRow />;
    //  }

     const handleDateChangeRaw = (e) => {
         e.preventDefault();
     }

    //  const handleDayChange = (from: Date, to: Date) => {
    //     setStartAt(from);
    //     setEndAt(to);
    //  };

    //   const handleTypeChange = (id: number) => {
    //     const types = [EHistoryFilterType.matched, EHistoryFilterType.unmatched, EHistoryFilterType.both];
    //     const type = types[id];
    //     if (type) {
    //       setType(JSON.stringify({
    //         type
    //       }));
    //     }
    //   };  

    var date = new Date();
    const minDate = date.setDate((new Date()).getDate() - 90);  
    return (
        <>
            {loading && <Spinner mode="agent" /> }
            <StatementTableWrapper>
                <TableHeadRow>
                    <TimeCol>
                        <span>{timeColLangKey}</span>
                    </TimeCol>
                    <DescriptionCol>
                    <span><Intl langKey="ACCOUNT_STATEMENT_TABLE@DESCRIPTION"/></span>
                    </DescriptionCol>
                    <TypeCol>
                    <span><Intl langKey="ACCOUNT_STATEMENT_TABLE@TYPE"/></span>
                    </TypeCol>
                    <OddsCol>
                    <span><Intl langKey="DETAIL_TABLE@ODDS"/></span>
                    </OddsCol>
                    <StakeCol>
                    <span><Intl langKey="DETAIL_TABLE@STAKE"/></span>
                    </StakeCol>
                    {mode === EHistoryTableType.current && (
                        <>
                           <LiabilityCol>
                                <span><Intl langKey="HISTORY_TABLE@LIABILITY"/></span>
                            </LiabilityCol>
                            <ProfitCol>
                                <span><Intl langKey="HISTORY_TABLE@POTENTIAL_PROFIT"/></span>
                            </ProfitCol>
                        </>
                    )}
                    {mode === EHistoryTableType.past && (
                        <>
                              <ProfitLossCol>
                                <span><Intl langKey="MEMBER@P2P_PROFIT_LOSS"/></span>
                            </ProfitLossCol>
                            <StatusCol>
                                <span><Intl langKey="HISTORY_TABLE@STATUS"/></span>
                            </StatusCol>
                        </>
                    )}
                </TableHeadRow>

                <TableBodyWrapper>
                {(error ? (
						<div>error</div>
					) : 
                    (orders.map((item: IOrder, i: number) => (
                        <MemberTableBodyRow key={i}>
                            <TimeCol>
                                <MobileHead>
                                    <span>{timeColLangKey}</span>
                                </MobileHead>
                                <TimeColContentWrapper>
                                    <DateText>
                                        <TimeZone format={'dd/MM/yyyy'}>
                                            {isSettled ? item.settledAt : item.createdAt}
                                        </TimeZone>
                                    </DateText>
                                    &nbsp;
                                    <TimeText>
                                        <TimeZone format={'HH:mm:ss'}>
                                            {isSettled ? item.settledAt : item.createdAt}
                                        </TimeZone>
                                    </TimeText>
                                </TimeColContentWrapper>
                            </TimeCol>
                            <DescriptionCol>
                                <Description
                                    mode={mode}
                                    type={type}
                                    eventName={item.eventName}
                                    marketName={item.marketName}
                                    selectionName={item.selectionName}
                                    marketType={item.marketType || EMarketType.MAIN}
                                    orderNumber={item.orderNumber}
                                    remark={item.clientRemark || ''}
                                    matchedTime={isSettled ? item.createdAt : item.updatedAt}
                                    isSettled={isSettled}
                                />
                            </DescriptionCol>
                            <TypeCol>
                                <MobileHead>
                                    <span>TYPE</span>
                                </MobileHead>
                                <TypeLabel>
                                    {[EMarketType.MAIN, EMarketType.Multi_Selection_Fancy].includes(
                                        item.marketType || -1,
                                    )
                                        ? item.side
                                        : item.side === 'BACK'
                                            ? 'YES'
                                            : 'NO'}
                                </TypeLabel>
                            </TypeCol>
                            <OddsCol>
                                <MobileHead>
                                    <span>ODDS</span>
                                </MobileHead>
                                {item.oddType === EOddsType.AM
                                    ? oddsUtil.EUtoAM(item.price).toFixed(2)
                                    : item.price.toFixed(2)}
                            </OddsCol>
                            <StakeCol>
                                <MobileHead>
                                    <span>STAKE</span>
                                </MobileHead>
                                <Amount>{util.numMultiply(item.stake, item.exchangeRate)}</Amount>
                            </StakeCol>
                            {!isSettled ? (
                                // Current
                                <>
                                    <LiabilityCol>
                                        <MobileHead>
                                            <span>LIABILITY</span>
                                        </MobileHead>
                                        {item.liability ? (
                                            <Income>
                                                {util.numMultiply(item.liability, item.exchangeRate)}
                                            </Income>
                                        ) : (
                                            '-'
                                        )}
                                    </LiabilityCol>
                                    <ProfitCol>
                                        <MobileHead>
                                            <span>POTENTIAL PROFIT</span>
                                        </MobileHead>
                                        {item.winlossCredit ? (
                                            <Income>
                                                {util.numMultiply(item.winlossCredit, item.exchangeRate)}
                                            </Income>
                                        ) : item.status === 'VOIDED' ? (
                                            '0'
                                        ) : (
                                            '-'
                                        )}
                                    </ProfitCol>
                                </>
                            ) : (

                                <>
                                    <ProfitLossCol>
                                        <MobileHead>
                                            <span>PROFIT LOSS</span>
                                        </MobileHead>
                                        {item.status === 'CHECKOUT' && item.winlossCredit ? (
                                            <Income>
                                                {util.numMultiply(item.winlossCredit, item.exchangeRate)}
                                            </Income>
                                        ) : (
                                            '-'
                                        )}
                                    </ProfitLossCol>
                                    <StatusCol>
                                        <MobileHead>
                                            <span>STATUS</span>
                                        </MobileHead>
                                        <StatusText>
                                            {item.status !== 'CHECKOUT'
                                                ? showStatus(item.status || '')
                                                : (item.winlossCredit || 0) > 0
                                                    ? 'WON'
                                                    : 'LOST'}
                                        </StatusText>
                                    </StatusCol>
                                </>
                            )}
                        </MemberTableBodyRow>
                        
                    ))
                    ))}
                    {orders.length === 0 && <EmptyWrapper><EmptyRow/></EmptyWrapper>}
                </TableBodyWrapper>

            </StatementTableWrapper>
        </>
    )
}


export const DateSelector = styled.div`
  position:relative;
  top:3px;
  
  font-weight: bold;
  display:inline-flex;
`;

export const TimeCol = styled(Col)`
	flex-basis: 10%;
`;

export const DescriptionCol = styled(Col)`
	flex-basis: 32%;
    display: flex;
    flex-direction: column;
`;

export const TypeCol = styled(Col)`
	flex-basis: 10%;
	justify-content: center;
	align-items: flex-start;

`;

export const OddsCol = styled(Col)`
	flex-basis: 10%;
	justify-content: center;
`;

export const StakeCol = styled(Col)`
	flex-basis: 10%;
	justify-content: center;

`;

export const LiabilityCol = styled(Col)`
	flex-basis: 12%;
	justify-content: center;
`;

export const ProfitCol = styled(Col)`
	flex-basis: 20%;
	justify-content: center;
	text-align: center;
`;

export const ProfitLossCol: any = styled(Col)`
	flex-basis: 16%;
	justify-content: center;
`;

export const StatusCol = styled(Col)`
	flex-basis: 16%;
	justify-content: center;
`;

export const TimeColContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const StatementTableWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    /* font-weight: bold; */
    text-transform: capitalize;
    letter-spacing: 0.66px;
    // background: #FDF2E5;
    background:#f4f8fc;
    color: #fff;
    border-bottom: none;
    box-shadow: rgb(0 0 0 / 10%) 0px 3px 5px;
    flex-wrap: wrap;
`;

const TableHeadRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    font-weight: bold;
    text-transform: capitalize;
    letter-spacing: 0.66px;
    // background: #D0B99F;
    background: ${theme('palette.secondary-background-color-new')};
    color: #fff;
    border-bottom: none;
    box-shadow: rgb(0 0 0 / 10%) 0px 3px 5px;
`;

const DatePickerWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: centre;
  justify-content: flex-start;
  position: absolute;
  right: 0;
  top: 12px;
`;

const BlockPick = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #E9F1F8;
  border-radius: 5px;
  padding: 0px 10px;
  margin-right: 10px;
  text-transform: capitalize;
  color: #203974;
  font-size: 12px;

  input {
    border: none;
    background: none;
    display: flex;
    height: 47px;
    text-align: center;
  }

  .react-datepicker__day--outside-month {
  color: transparent !important;
  pointer-events: none;
}
`;

const Tittle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #013766;
  
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  text-transform: capitalize;
  padding-bottom: 10px;
`;

const CalenderIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-image: url(${DatePickerIcon});
  background-size: auto;
  background-repeat: no-repeat;
  margin-right: 10px;
`;

const EmptyWrapper = styled.div`
    width: 100%;
    /* justify-content: center;  */
    text-transform: capitalize;
    letter-spacing: 0.66px;
    // background: #FDF2E5;
    border-bottom: none;
    position:relative;
`;
